var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview"},[_c('v-card',{staticClass:"text-center py-4 px-12",class:_vm.previewClasses,attrs:{"outlined":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }